import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { MyTableComponent, Input, Button } from "components"
import { Box } from "theme-ui"
import tittle from "./Tittle.png"

export const ModuleSystem = () => {
 // language translator
 const { t } = useTranslation("translation")
 const [selectedData, setSelectedData] = useState<any[]>([])

 const data = [
  {
   firstname: "Anlagengruppenbearbeitung",
  },
  {
   firstname: "Anlagengruppenbearbeitung",
  },
  {
   firstname: "Anlagengruppenbearbeitung",
  },
  {
   firstname: "Anlagengruppenbearbeitung",
  },
  {
   firstname: "Anlagengruppenbearbeitung",
  },
  {
   firstname: "Anlagengruppenbearbeitung",
  },
  {
   firstname: "Anlagengruppenbearbeitung",
  },
 ]

 const columns = [
  { Header: t("module"), accessor: "firstname" },
  {
   Header: "Forum Gera",
   Cell: () => (
    <div className="flex justify-center">
     <div>
      <Button size={"tableSmallSize"} color={"green"}>
       {t("active")}
      </Button>
     </div>
    </div>
   ),
  },
  {
   Header: "Test server",
   Cell: () => (
    <div className="flex justify-center">
     <div>
      <Button size={"tableSmallSize"} color={"green"}>
       {t("active")}
      </Button>
     </div>
    </div>
   ),
  },
 ]

 useEffect(() => {
  if (data) {
   setSelectedData(data)
  }
  // eslint-disable-next-line
 }, [])
 const searchHandler = (keyword: any) => {
  if (keyword !== "") {
   const filterData: any = data?.filter(
    (item) => item?.firstname?.toLowerCase()?.indexOf(keyword.toLowerCase()) !== -1,
   )
   setSelectedData([...filterData])
  } else {
   setSelectedData(data)
  }
 }

 return (
  <div className="w-[96%] mx-auto relative h-screen md:h-screen lg:h-full pt-6">
   <Box bg="highlight" color="text-black">
    <div className="py-3 px-3 flex justify-between items-center">
     <h1 className="Jakarta-font font-semibold">{t("connectionQuality")}</h1>

     <div className="flex items-center justify-end">
      <p className="Jakarta-font">{t("category")}</p>

      <div className="bg-white h-8 w-12 rounded mx-4  border-light-gray border-[1.5px] flex justify-center items-center">
       <img className="w-4" src={tittle} alt="tittlesign" />
      </div>

      {/* ======== SearchHandler  ======== */}
      <div className="w-1/4 hover:w-[45%] transition-all delay-150 duration-700">
       <Input
        onChange={searchHandler}
        className="outline-none text-black border-light-gray border-[1.5px] h-8 rounded  pl-2    "
        placeholder={( t("search") )}
        type="search"
       />
      </div>
     </div>
    </div>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent
    fullHeight={false}
    columns={columns}
    data={data ? selectedData : []}
    paginate={true}
   />
  </div>
 )
}
